module.exports = __webpack_public_path__ + "media/raiden_shogun_boss_theme.5fce40b8.mp3";